//课中活动讨论
export const SIGN_LIST = 'sign_list'
export const SIGN_INFO = 'sign_info'